import { getPermissions } from "@/helper/collection";
import { authenticationService } from "@/services/AuthenticationService";

export const PagesRoutes = {
  path: "pages",
  name: "Pages",
  redirect: "pages/view-list-of-pages",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/",
      name: "",
      component: () =>
        import("@/components/Pages/ReportsContainer/reportsMaster"),
      meta: {},
    },
    {
      path: "list-of-pages",
      name: "List of Pages",
      component: () => import("@/components/Pages/listOfPages.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          207,
          2
        ),
      },
    },
    {
      path: "view-list-of-pages",
      name: "View List of Pages",
      component: () => import("@/components/Pages/viewListOfPages.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          208,
          2
        ),
      },
    },
    {
      path: "/",
      name: "",
      component: () =>
        import("@/components/Pages/ReportsContainer/reportsMaster"),
      meta: {},
    },
    {
      path: "edit-popup-page",
      name: "Edit Popup Pages",
      component: () => import("@/components/Pages/add-popup-pages.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          209,
          2
        ),
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/pagesRoutes.js